import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { CustomPasswordValidators } from './custom-password-new-validators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-change-password-new',
  templateUrl: './change-password-new.page.html',
  styleUrls: ['./change-password-new.page.scss'],
})
export class ChangePasswordNewPage implements OnInit {
  changePasswordform: UntypedFormGroup;
  token: any;
  regemail: any;
  currentPasswordHide = true;
  newPasswordHide = true;
  confirmPasswordHide = true;

  breadcrumbList = [
    {
      label: 'Change Password',
      embedurl: true,
      url: '/baseapp/change-password-new'
    }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public helperService: HelperService
    ) { }

    ngOnInit() {
      this.currentPasswordHide = true;
      this.newPasswordHide = true;
      this.confirmPasswordHide = true;
      this.changePasswordform = this.formBuilder.group({
        'currentPassword': [
          '', 
          Validators.compose([Validators.required])
        ],
        'newPassword': [
          '',
          Validators.compose([
            // check whether the entered password has a number
            CustomPasswordValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has a upper case letter
            CustomPasswordValidators.patternValidator(/[A-Z]/, {
              hasUpperCase: true 
            }),
            // check whether the entered password has a lower case letter
            CustomPasswordValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomPasswordValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(8)
          ])
        ],
        'confirmPassword': [''],
      },
      {
        // check whether our password and confirm password match
        validator: CustomPasswordValidators.passwordMatchValidator
      });
  
    }

    get changePasswordControls() { return this.changePasswordform.controls; }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  onChangePasswordSubmit() {
    // this.submitted = true;
    if (this.changePasswordform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    };

    const currentPassword = this.changePasswordform.value.currentPassword;
    const newPassword = this.changePasswordform.value.newPassword;
  
    if (currentPassword === newPassword) {
      this.helperService.presentToast("Your new password is the same as the old password. Please pick a new password.", 2000);
      return;
    }

    this.getStorage().then((_storage)=>{
      if(_storage){
        let payload = {
          current_password: currentPassword,
          new_password: newPassword
        };
        this.helperService.loader();
        this.backendService.PostAPICall('changeUserPassword', payload, _storage.token)
          .subscribe(
            (data) => {
                // this.submitted = false;
                this.changePasswordform.reset();
                this.helperService.closeLoader();
                this.helperService.presentToast('Password has been changed successfully.', 2000);
                this.login();
            },
            (error) => {
              //console.log(error);              
              this.helperService.handleError(error);
              this.helperService.closeLoader();
            })
      }else{
        this.helperService.presentToast("Oops! Something went wrong", 2000);
      }
    
    })
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.helperService.closeLoader();
    }, 2000);
  }
  login(){
    this.getStorage().then((res)=>{
      console.log(res)
      let payload = {
        id:res.userId
      }
      this.backendService.PostAPICall('logout', payload, res.token)
        .subscribe(data=>{
          // this.helperService.presentToast(data.msg,100);
          this.storage.clear();
          this.router.navigate(['/login']);
        },
        (error)=>{
          console.log(error)
        })
    })
  }
}
